import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

/**
 * @function getUser
 * @desc This returns user info if the user is logged in
 */
export const getUser = function() {
  let user = localStorage.getItem("user");
  let authToken = localStorage.getItem("authToken");
  return user && authToken ? JSON.parse(user) : null;
};

/**
 * @function getChatkitId
 * @desc This returns logged in users chat kit id
 */
export const getChatkitId = () => {
  const chatId = localStorage.getItem("chatkitId");
  return chatId;
};

/**
 * @function getCoordinatorId
 * @desc This returns coordinator ID if
 * the user is logged in
 */
export const getCoordinatorId = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const parsedUser = JSON.parse(user);
    let coordinatorId = null;
    if (parsedUser.user_accounts) {
      parsedUser.user_accounts.map(account => {
        if (account.account_type === "care_coordinator") {
          coordinatorId = account.coordinator_id;
        }
      });
    }
    return coordinatorId;
  } else {
    return null;
  }
};

/**
 * @function isLoggedIn
 * @desc This checks whether user is logged in or not
 */
export const isLoggedIn = () => {
  const user = localStorage.getItem("user");
  const authToken = localStorage.getItem("authToken");

  if (user) {
    const loggedInUser = JSON.parse(user);
    // const adminAccount = loggedInUser.user_accounts.filter(ua => {
    //   return ua.account_type === "wp_admin";
    // });

    if (process.env.REACT_APP_ENVIRONMENT === "production") {
      Sentry.configureScope(scope => {
        scope.setTag("username", "kulcare_admin");
        scope.setUser({
          id: loggedInUser.id,
          username: "kulcare_admin",
          phoneNumber: loggedInUser.phone_number
        });
      });
    }
  }
  return user && authToken ? true : false;
};

/**
 * @function capitalize
 * @desc This capitalizes the string
 */
export const capitalize = s => {
  if (s === "" || s === null) {
    return;
  }
  return s.toLowerCase().replace(/\b./g, function(a) {
    return a.toUpperCase();
  });
};
